import React, { useState, useEffect } from 'react';
import {
  Form,
  Modal,
  Row,
  Col,
} from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import DivisionSelector from '../common/inputs/DivisionSelector';
import { getImportModalComponents } from './workflowMarketplace.helpers';
import OnTraccrButton from '../common/buttons/OnTraccrButton';

export default function WorkflowMarketplaceImportModal({
  workflow,
  importWorkflow,
  onClose,
  loading
}) {
  const divisions = useSelector((state) => state.settings.divisions);
  const [form] = Form.useForm();

  const [selectedDivision, setSelectedDivision] = useState();

  useEffect(() => {
    const divisionList = Object.values(divisions);

    if (divisionList.length === 1) {
      setSelectedDivision(divisionList[0].id);
    } else {
      setSelectedDivision();
    }
  }, [workflow?.id, divisions]);

  if (!workflow) return null;
  return (
    <Modal
      visible
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      wrapClassName="workflow-marketplace-import-modal-wrap"
      className="workflow-marketplace-import-modal"
    >
      <div className="workflow-marketplace-import-modal-title">Import Workflow?</div>
      <div className="workflow-marketplace-import-modal-description">You are about to import the following workflow <b>{workflow.name}</b> into your account.</div>
      <Form form={form}>
        <Form.Item
          label="Select Division"
          name="division"
          required
          className="workflow-marketplace-import-modal-division-selector-form-item"
        >
          <DivisionSelector
            divisionId={selectedDivision}
            onChange={setSelectedDivision}
          />
        </Form.Item>
        <div className="workflow-marketplace-import-modal-components-container">
          <div className="workflow-marketplace-import-modal-components-sub-title">This will import all the components required for the workflow.</div>
          <ul className="workflow-marketplace-import-modal-components-list">
            {getImportModalComponents(workflow.components).map((component) => (
              <li key={component} className="workflow-marketplace-import-modal-components-list-item">{component}</li>
            ))}
          </ul>
        </div>
        <div className="workflow-marketplace-import-modal-warning-container">
          <Row>
            <Col span={2} style={{ display: 'flex', justifyContent: 'center' }}>
              <WarningOutlined className="workflow-marketplace-import-modal-warning-icon" />
            </Col>
            <Col span={22}>
              <div className="workflow-marketplace-import-modal-warning-title">This action cannot be undone.</div>
              <div className="workflow-marketplace-import-modal-warning-description">Once imported, the workflow and all its components will be permanently added to your account.</div>
            </Col>
          </Row>
        </div>
        <Row className="workflow-marketplace-import-modal-buttons">
          <OnTraccrButton
            title="Cancel"
            onClick={onClose}
            type="cancel"
          />
          <OnTraccrButton
            title="Import Workflow"
            onClick={() => importWorkflow(workflow, selectedDivision ? [selectedDivision] : [])}
            loading={loading}
            disabled={!selectedDivision}
          />
        </Row>
      </Form>
    </Modal>
  );
}

WorkflowMarketplaceImportModal.propTypes = {
  workflow: PropTypes.shape({
    name: PropTypes.string.isRequired,
    components: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(PropTypes.string).isRequired,
    })).isRequired,
  }).isRequired,
  importWorkflow: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
